
@if (isOpen() && plan(); as selectedPlan) {
  <div (click)="onBackdropClick($event)" class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[2000] backdrop-blur-sm animate-fade-in-fast">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden flex flex-col max-h-[95vh]" (click)="$event.stopPropagation()">
      
      <!-- Header -->
      <div class="bg-slate-900 p-6 text-white flex justify-between items-start flex-shrink-0">
        <div>
          <h2 class="text-xl font-bold flex items-center gap-2">
            <i class="fa-solid fa-crown text-yellow-400"></i> อัปเกรดแพ็กเกจ
          </h2>
          <p class="text-slate-400 text-sm mt-1">สมัครสมาชิก: <span class="text-white font-bold">{{ selectedPlan.name }}</span></p>
        </div>
        <div class="text-right">
          <p class="text-2xl font-bold text-emerald-400">฿{{ selectedPlan.price_monthly | number:'1.0-0' }}</p>
          <p class="text-xs text-slate-400">/ เดือน</p>
        </div>
      </div>

      <!-- Body -->
      <div class="p-6 overflow-y-auto">
        
        <!-- Step 1: Selection -->
        @if(currentStep() === 'select') {
            <p class="text-sm text-gray-600 mb-4 font-bold">เลือกช่องทางการชำระเงิน:</p>
            <div class="grid grid-cols-1 gap-3">
                <button type="button" (click)="selectBankTransfer()" class="flex items-center justify-between p-4 border-2 border-emerald-100 bg-emerald-50 rounded-xl hover:bg-emerald-100 transition-all group w-full cursor-pointer">
                    <div class="flex items-center gap-3">
                        <div class="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm text-emerald-600">
                            <i class="fa-solid fa-building-columns text-2xl"></i>
                        </div>
                        <div class="text-left">
                            <p class="font-bold text-slate-800">โอนเงินธนาคาร</p>
                            <p class="text-xs text-slate-500">Bank Transfer / QR Code</p>
                        </div>
                    </div>
                    <i class="fa-solid fa-chevron-right text-emerald-400 group-hover:text-emerald-600"></i>
                </button>

                <!-- CREDIT CARD BUTTON: Direct Binding -->
                <button type="button" (click)="selectCreditCard()" class="flex items-center justify-between p-4 border-2 border-slate-100 bg-slate-50 rounded-xl hover:bg-blue-50 hover:border-blue-200 transition-all group w-full cursor-pointer">
                    <div class="flex items-center gap-3">
                        <div class="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm text-blue-500">
                            <i class="fa-solid fa-credit-card text-2xl"></i>
                        </div>
                        <div class="text-left">
                            <p class="font-bold text-slate-800">บัตรเครดิต/เดบิต</p>
                            <p class="text-xs text-slate-500">Visa, Mastercard (Opn Payments)</p>
                        </div>
                    </div>
                    <i class="fa-solid fa-chevron-right text-slate-300 group-hover:text-blue-400"></i>
                </button>
            </div>
        }

        <!-- Step 2A: Bank Transfer -->
        @if(currentStep() === 'transfer') {
            <div class="text-center space-y-6">
                <!-- ยอดเงิน -->
                <div class="bg-emerald-50 border border-emerald-100 p-3 rounded-lg flex justify-between items-center">
                    <span class="text-emerald-800 font-bold">ยอดชำระ (Total):</span>
                    <span class="text-2xl font-black text-emerald-600">฿{{ selectedPlan.price_monthly | number:'1.2-2' }}</span>
                </div>

                <!-- Bank Info -->
                <div class="bg-white border-2 border-slate-200 rounded-xl p-4 text-left relative overflow-hidden">
                    <div class="absolute top-0 right-0 bg-slate-100 text-slate-500 text-[10px] px-2 py-1 rounded-bl-lg font-bold uppercase">Bank Account</div>
                    
                    <div class="flex items-center gap-3 mb-2">
                        <div class="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center text-white shadow-sm">
                            <i class="fa-solid fa-building-columns"></i>
                        </div>
                        <div>
                            <p class="text-xs text-slate-500 font-bold">{{ PLATFORM_BANK_NAME }}</p>
                            <p class="text-xs text-slate-400">ชื่อบัญชี: {{ PLATFORM_ACCOUNT_NAME }}</p>
                        </div>
                    </div>

                    <div class="flex justify-between items-center bg-slate-50 p-3 rounded-lg border border-slate-200">
                        <span class="font-mono font-bold text-xl text-slate-800 tracking-wider">{{ PLATFORM_ACCOUNT_NUMBER }}</span>
                        <button (click)="copyAccountNumber()" class="text-emerald-600 hover:text-emerald-800 text-xs font-bold flex items-center gap-1 bg-white px-2 py-1 rounded border border-emerald-200 shadow-sm">
                            <i class="fa-regular fa-copy"></i> คัดลอก
                        </button>
                    </div>
                </div>

                <!-- QR Code -->
                <div class="flex flex-col items-center bg-slate-50 p-3 rounded-xl border border-slate-200">
                    <div class="bg-white p-2 rounded-lg shadow-sm border border-slate-100 inline-block">
                         <img [src]="qrCodeUrl()" alt="PromptPay QR" class="w-32 h-32 mix-blend-multiply">
                    </div>
                    <p class="text-[10px] text-slate-400 mt-2">
                        <i class="fa-solid fa-link"></i> QR นี้ผูกกับบัญชีด้านบน
                    </p>
                </div>

                <!-- Upload -->
                <div class="border-t pt-4">
                    <label class="block w-full cursor-pointer">
                        <input type="file" (change)="onFileSelected($event)" accept="image/*" class="hidden">
                        <div class="w-full border-2 border-dashed border-slate-300 rounded-lg p-4 hover:bg-slate-50 transition-colors text-center relative" 
                             [class.border-emerald-500]="uploadedSlip() && !verificationError()" 
                             [class.border-red-500]="verificationError()"
                             [class.bg-emerald-50]="uploadedSlip() && !verificationError()"
                             [class.bg-red-50]="verificationError()">
                            
                            @if(isCheckingSlip()) {
                                <div class="absolute inset-0 bg-white/80 backdrop-blur-[1px] z-10 flex items-center justify-center rounded-lg">
                                    <i class="fa-solid fa-circle-notch animate-spin text-3xl text-emerald-500"></i>
                                </div>
                            }

                            @if(verificationError()) {
                                <div class="text-red-600 font-bold flex flex-col items-center justify-center gap-1 animate-pulse">
                                    <i class="fa-solid fa-circle-xmark text-3xl"></i>
                                    <span>ตรวจสอบไม่ผ่าน</span>
                                </div>
                                <p class="text-xs text-red-500 mt-1">คลิกเพื่ออัพโหลดใหม่</p>
                            } @else if(uploadedSlip()) {
                                <div class="text-emerald-700 font-bold flex items-center justify-center gap-2">
                                    <i class="fa-solid fa-check-circle"></i> สลิปพร้อมตรวจสอบ
                                </div>
                                <p class="text-xs text-emerald-600 mt-1">{{ uploadedFileName() }}</p>
                                <p class="text-xs text-slate-400 mt-2">ระบบจะตรวจสอบเลขบัญชีในสลิปอัตโนมัติ</p>
                            } @else {
                                <i class="fa-solid fa-cloud-arrow-up text-3xl text-slate-300 mb-2"></i>
                                <p class="text-sm font-bold text-slate-600">อัพโหลดสลิป (E-Slip)</p>
                            }
                        </div>
                    </label>
                    
                    @if(verificationError()) {
                        <div class="mt-3 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm flex items-start gap-2">
                            <i class="fa-solid fa-circle-exclamation mt-0.5 flex-shrink-0"></i>
                            <span class="font-medium">{{ verificationError() }}</span>
                        </div>
                    }
                </div>
            </div>
        }

        <!-- Step 2B: Credit Card -->
        @if(currentStep() === 'card') {
            <div class="space-y-4">
                <div class="bg-blue-50 border border-blue-100 p-4 rounded-lg flex justify-between items-center">
                    <span class="text-blue-800 font-bold">ยอดชำระ (Total):</span>
                    <span class="text-2xl font-black text-blue-600">฿{{ selectedPlan.price_monthly | number:'1.2-2' }}</span>
                </div>

                <div class="bg-slate-50 p-4 rounded-lg border border-slate-200">
                    <div class="space-y-3">
                        <div>
                            <label class="block text-xs font-bold text-slate-700 mb-1">Name on Card</label>
                            <input type="text" [(ngModel)]="cardName" placeholder="Full Name" class="w-full border-slate-300 rounded p-2 text-sm focus:ring-blue-500 focus:border-blue-500">
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-slate-700 mb-1">Card Number</label>
                            <div class="relative">
                                <input type="text" [(ngModel)]="cardNumber" placeholder="0000 0000 0000 0000" maxlength="16" class="w-full border-slate-300 rounded p-2 pl-9 text-sm focus:ring-blue-500 focus:border-blue-500 font-mono tracking-wide">
                                <div class="absolute left-3 top-2.5 text-slate-400"><i class="fa-solid fa-credit-card"></i></div>
                            </div>
                        </div>
                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <label class="block text-xs font-bold text-slate-700 mb-1">Expiry Date</label>
                                <div class="flex gap-2">
                                    <input type="text" [(ngModel)]="expiryMonth" placeholder="MM" maxlength="2" class="w-full border-slate-300 rounded p-2 text-sm text-center">
                                    <span class="self-center">/</span>
                                    <input type="text" [(ngModel)]="expiryYear" placeholder="YYYY" maxlength="4" class="w-full border-slate-300 rounded p-2 text-sm text-center">
                                </div>
                            </div>
                            <div>
                                <label class="block text-xs font-bold text-slate-700 mb-1">Security Code</label>
                                <div class="relative">
                                     <input type="password" [(ngModel)]="securityCode" placeholder="CVC" maxlength="3" class="w-full border-slate-300 rounded p-2 text-sm text-center">
                                     <div class="absolute right-3 top-2.5 text-slate-400 text-xs"><i class="fa-solid fa-lock"></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                @if(omiseError()) {
                    <div class="bg-red-50 text-red-600 p-3 rounded-lg text-sm border border-red-200 flex items-start gap-2">
                        <i class="fa-solid fa-circle-exclamation mt-0.5"></i> <span>{{ omiseError() }}</span>
                    </div>
                }

                <div class="text-xs text-center text-slate-400 mt-2">
                    <i class="fa-solid fa-lock"></i> Secure Payment by Opn Payments (Omise)
                </div>
            </div>
        }

      </div>

      <!-- Footer -->
      <div class="bg-slate-50 p-4 border-t flex justify-between items-center flex-shrink-0">
        <button (click)="onClose()" [disabled]="isProcessing()" class="px-4 py-2 text-slate-500 hover:text-slate-800 font-semibold text-sm disabled:opacity-50">
            ยกเลิก
        </button>

        @if(currentStep() === 'transfer') {
            <button (click)="verifySlip()" [disabled]="!uploadedSlip() || isProcessing()" 
            class="px-6 py-2 rounded-lg text-white font-bold shadow-md transition-all flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 disabled:bg-slate-300 disabled:cursor-not-allowed">
            @if(isProcessing()) {
                <i class="fa-solid fa-spinner animate-spin"></i> กำลังตรวจสอบ...
            } @else {
                <i class="fa-solid fa-magnifying-glass-dollar"></i> ยืนยันการโอน
            }
            </button>
        } @else if (currentStep() === 'card') {
             <button (click)="submitCardPayment()" [disabled]="isProcessing()" 
            class="px-6 py-2 rounded-lg text-white font-bold shadow-md transition-all flex items-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:bg-slate-300 disabled:cursor-not-allowed">
            @if(isProcessing()) {
                <i class="fa-solid fa-spinner animate-spin"></i> Processing...
            } @else {
                Pay Now
            }
            </button>
        }
      </div>

    </div>
  </div>
}
